import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import Signup from '../pages/Signup';
import Profile from '../pages/Profile';
import Search from '../pages/Search';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={ Login } />

      <Route path="/dashboard" component={ Dashboard } isPrivate/>
      <Route path="/register" component={ Register } isPrivate/>
      <Route path="/signup" component={ Signup } isPrivate/>
      <Route path="/profile" component={ Profile } isPrivate/>
      <Route path="/search" component={ Search } isPrivate/>

      <Route path="/" component={() => <h1>404</h1>}/>
    </Switch>
  );
}